import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Collar } from '@types';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HoleListResolver implements Resolve<any> {
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Collar[]> {
        return of([]);
    }
}

